<template>
  <div class="home">
    <Navigation></Navigation>
    <div class="section1 section">
      <img src="../assets/images/banner_pc.jpg" alt="" class="bg" />
      <img src="../assets/images/banner_mb.jpg" alt="" class="mb_bg" />
      <img
        class="play-btn"
        src="../assets/images/play.png"
        alt=""
        @click="play"
      />
      <div class="download">
        <a
          href="https://itunes.apple.com/cn/app/id1357435027"
          target="_blank"
          class="apple"
        >
          <img src="../assets/images/apple.png" alt="" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.szckhd.jwgly.azjp"
          target="_blank"
          class="android"
        >
          <img src="../assets/images/android.png" alt="" />
        </a>
      </div>
    </div>
    <div class="section2 section">
      <div class="swiper">
        <swiper :options="swiperOption" v-if="swiperList.length">
          <swiper-slide v-for="(slide, key) in swiperList" :key="key">
            <div align="center">
              <a :href="slide.url"
                ><img :src="slide.img" alt="" />
                <img src="../assets/images/border1.png" alt="" />
              </a>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="news">
        <div class="reel">
          <ul class="news_tags">
            <li
              v-for="(item, index) in newsList"
              :key="index"
              @click="goDetail(item)"
            >
              <span class="tag">{{ item.tag }}</span>
              <span class="title">{{ item.title }}</span>
              <span class="time">{{ getNowTime(item.c_time) }}</span>
            </li>
          </ul>
          <div class="more">
            <a>
              <router-link to="/news">
                <img src="../assets/images/more.png" alt="" />
              </router-link>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section3 section">
      <img src="../assets/images/bg.jpg" alt="" class="bg" />
      <img src="../assets/images/bg_footer.jpg" alt="" class="bg" />
      <img src="../assets/images/mb_bg.png" alt="" class="mb_bg" />
      <img src="../assets/images/mb_bg_footer.jpg" alt="" class="mb_bg" />
      <div class="frist">
        <a
          href="https://hrcdn-exchange.ckhdjk.com/jpex_exchangePage/index.html"
          target="_blank"
        >
          <img src="../assets/images/twitter_title.png" alt="" class="title" />
        </a>
        <!-- <div class="list">
          <a
            class="twitter-timeline"
            data-width="100%"
            data-height="100%"
            data-theme="white"
            href="https://twitter.com/wagayabou?ref_src=twsrc%5Etfw"
          ></a>
        </div> -->
      </div>
      <div class="second">
        <div class="roles">
          <div v-for="(item, index) in roles" :key="index">
            <div @mouseover="active = index" @mouseout="active = null">
              <img
                :src="item.img"
                alt=""
                class="role_img"
                v-show="active !== index"
              />
              <img
                :src="item.img_hover"
                alt=""
                class="role_img"
                v-show="active === index"
              />
            </div>
            <img
              :src="item.img_txt"
              alt=""
              class="role_txt"
              @mouseover="active = index"
              @mouseout="active = null"
              @click="goRoles(index)"
            />
          </div>
          <img
            src="../assets/images/role_cloud.png"
            alt=""
            class="role_cloud"
          />
        </div>
      </div>
    </div>
    <div class="video-mask" v-show="isPlay" @click="pause">
      <video
        class="video"
        id="video"
        v-show="isPlay"
        src="../assets/images/video.mp4"
        controls=""
      ></video>
    </div>

    <div class="footer">
      <img src="../assets/images/footer_pc.png" alt="" class="footer_bg" />
      <img src="../assets/images/footer_mb.png" alt="" class="mb_footer_bg" />
      <a href="./business.html" class="business_btn" target="_blank"></a>
      <a href="./funds.html" class="funds_btn" target="_blank"></a>
      <a
        class="pro_btn"
        href="https://jk-dl.szckhd.com/info/j/service.html"
        target="_blank"
      ></a>
      <a
        class="user_btn"
        href="https://jk-dl.szckhd.com/info/j/privacy.html"
        target="_blank"
      ></a>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Navigation from "../components/navigation";
import api from "@/api";
import getNowTime from "@/methods/getNowTime";

export default {
  name: "home",
  components: {
    Navigation,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      isPlay: false,
      isSky: false,
      active: null, // 角色移入变亮
      newsList: [],
      pageNum: 1,
      pageSize: 6,
      totalPages: null,
      cartoonContent: "",
      swiperList: [],
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          delay: 3000, // 自动切换的时间间隔（单位ms）
        },
        initialSlide: 0,
        loop: true,
        pagination: { el: ".swiper-pagination", clickable: true }, // 分页按钮
        paginationClickable: true,
        onSlideChangeEnd: (swiper) => {
          //console.log('onSlideChangeEnd', swiper.realIndex)
        },
      },
      rolesIndex: {
        0: 3,
        1: 2,
        2: 5,
        3: 1,
        4: 0,
        5: 4,
        6: 6,
      },
    };
  },
  computed: {
    roles() {
      let arr = [
        "jiancheng",
        "wuyi",
        "nvjie",
        "wuhu",
        "menke",
        "meiren",
        "suitang",
      ];
      return this.imgPath(arr);
    },
  },
  mounted() {
    // 资讯列表加载
    this.getNewsList();
    //咨询图
    this.getNewsImgList();
    try {
      twttr.widgets.load();
    } catch (error) {
      console.log(error);
    }

    /*以下是渲染CANVAS画布中的视频*/
  },
  methods: {
    getNowTime: getNowTime,
    play() {
      this.isPlay = true;
      let vid = document.getElementById("video");
      vid.play();
    },
    pause() {
      this.isPlay = false;
      let vid = document.getElementById("video");
      vid.pause();
    },
    imgPath(arr) {
      let rolesArr = [];
      arr.map((e) => {
        let obj = {};
        obj["img"] = `${this._myPath}/${e}.png`;
        obj["img_hover"] = `${this._myPath}/${e}_hover.png`;
        obj["img_txt"] = `${this._myPath}/${e}_txt.png`;
        rolesArr.push(obj);
      });
      return rolesArr;
    },
    getNewsList(pageNum, pageSize) {
      let pageN = pageNum || this.pageNum;
      let pageS = pageSize || this.pageSize;
      api
        .getNewsList(
          JSON.stringify({
            pageNum: pageN,
            pageSize: pageS,
          })
        )
        .then((res) => {
          let resData = res.data;
          if (resData.code === 200) {
            this.pageNum = resData.currentPage;
            this.newsList = resData.data;
            this.totalPages = resData.totalPages;
          }
        });
    },
    goDetail(item) {
      let tagId = null;
      if (item.tag == "お知らせ") {
        tagId = 1;
      } else if (item.tag == "イベント") {
        tagId = 2;
      } else {
        tagId = 3;
      }
      this.$router.push(`/newsDetail?tagId=${tagId}&newsId=${item.n_id}`);
    },
    goRoles(index) {
      this.$router.push(`/roles?roleId=${this.rolesIndex[index]}`);
    },
    getNewsImgList(pageNum, pageSize) {
      let pageN = pageNum || this.pageNum;
      let pageS = pageSize || this.pageSize;
      api
        .getNewsImgList(
          JSON.stringify({
            pageNum: pageN,
            pageSize: pageS,
          })
        )
        .then((res) => {
          let resData = res.data;
          if (resData.code === 200 && resData.data.length > 0) {
            this.swiperList = resData.data;
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home {
  width: 100%;
  height: 100%;
}
.bg {
  display: block;
  width: 100%;
}
.mb_bg {
  display: none;
}
.section {
  position: relative;
  width: 100%;
}
.video-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99;
  video {
    position: absolute;
    width: 55%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.section1 {
  position: relative;
  font-size: 0;
  img {
    width: 100%;
  }
  .play-btn {
    position: absolute;
    width: 7%;
    top: 33%;
    left: 84.8%;
    cursor: pointer;
  }
  .download {
    position: absolute;
    bottom: 20px;
    right: 8%;
    // transform: translate(-50%, -50%);
    a {
      display: block;
      width: 600px;
      margin: 70px;
      text-align: right;
      position: relative;
      overflow: hidden;
    }
    img {
      display: block;
      width: 100%;
      cursor: pointer;
    }
    // .android:after,
    // .apple:after {
    //     content: '';
    //     background: #ddd;
    //     display: block;
    //     position: absolute;
    //     width: 10%;
    //     height: 100%;
    //     border-radius: 100px;
    //     top: -150px;
    //     left: 0px;
    //     transform: scale(1, 1) rotate(45deg);
    //     opacity: 0;
    //     animation: mymove 1s ease-in-out infinite;
    // }
    @keyframes mymove {
      0% {
        opacity: 0.6;
        transform: scale(1, 1) rotate(45deg);
      }
      100% {
        opacity: 0;
        transform: scale(20, 20) rotate(45deg);
      }
    }
  }
}
.section2 {
  position: relative;
  width: 100%;
  .news,
  .swiper {
    width: 50%;
    display: inline-block;
    position: relative;
    vertical-align: top;
  }
  .swiper {
    height: 1600px;
    z-index: 2;
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-slide {
      }
      a,
      img {
        display: block;
        width: 100%;
      }
    }
    .swiper-pagination {
      bottom: 160px;
    }
    /deep/.swiper-pagination-bullet {
      width: 70px;
      height: 15px;
      border-radius: 0;
      margin: 0 20px;
      background: url("../assets/images/swiper_off.png") no-repeat;
      background-size: 100% 100%;
    }
    /deep/.swiper-pagination-bullet-active {
      background: url("../assets/images/swiper_on.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .news {
    height: 1540px;
    background: url("../assets/images/news_bg_home.png") no-repeat;
    background-size: 100% 100%;
    .news_tags {
      position: absolute;
      width: 90%;
      height: 1100px;
      top: 100px;
      left: 50%;
      overflow: auto;
      transform: translateX(-50%);
      li {
        font-size: 45px;
        color: #000;
        font-weight: 500;
        padding-bottom: 25px;
        margin-bottom: 50px;
        cursor: pointer;

        .tag {
          display: inline-block;
          width: 300px;
          padding: 20px 0px;
          background-color: #ae7b37;
          border-radius: 10px;
          color: #fff;
        }
        .title {
          display: inline-block;
          width: 850px;
          margin: 0 30px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          vertical-align: bottom;
        }
        &:nth-child(1) {
          color: red;
          .tag {
            background-color: red;
          }
        }
      }
    }
    .more {
      position: absolute;
      width: 15%;
      bottom: 15%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }
  }
}

.frist {
  position: absolute;
  top: 8%;
  width: 60%;
  left: 50%;
  transform: translateX(-50%);
  .title {
    width: 100%;
    margin-bottom: 100px;
  }

  .list {
    width: 100%;
    height: 2100px;
    overflow: hidden;
    border: 1px solid #bbb;
    .twitter-timeline {
      width: 100%;
      height: 100%;
      // min-height: 400px !important;
    }
    iframe .timeline-Footer {
      display: none !important;
    }
  }
}
.second {
  width: 100%;
  // height: 100%;
  position: absolute;
  bottom: 650px;
  left: 0;
  .roles {
    // margin: 0 auto;
    position: relative;
    width: 100%;
    height: 1800px;
    left: 50%;
    transform: translateX(-50%);
    > div {
      position: absolute;
      top: 0;
      left: 900px;
      cursor: pointer;
      .role_img {
        width: 780px;
      }
      .role_txt {
        width: 224px;
        position: absolute;
      }
      &:nth-child(1) {
        top: 90px;
        .role_img {
          width: 780px;
        }
        .role_txt {
          top: 300px;
          left: 100px;
        }
      }
      &:nth-child(2) {
        top: -40px;
        left: 1300px;
        .role_img {
          width: 1200px;
        }
        .role_txt {
          top: 380px;
          left: 350px;
        }
      }
      &:nth-child(3) {
        left: 1720px;
        top: 110px;
        z-index: -1;
        .role_img {
          width: 1350px;
        }
        .role_txt {
          top: 380px;
          right: 300px;
        }
      }
      &:nth-child(4) {
        top: 700px;
        left: 680px;
        z-index: 2;
        .role_img {
          width: 1000px;
        }
        .role_txt {
          position: absolute;
          left: 300px;
          top: 280px;
        }
      }
      &:nth-child(5) {
        left: 1200px;
        top: 650px;
        z-index: 1;
        .role_img {
          width: 1150px;
        }
        .role_txt {
          position: absolute;
          left: 450px;
          top: 300px;
        }
      }
      &:nth-child(6) {
        left: 1800px;
        top: 680px;
        .role_img {
          width: 850px;
        }
        .role_txt {
          position: absolute;
          left: 500px;
          top: 280px;
          z-index: 5;
        }
      }
      &:nth-child(7) {
        left: 2450px;
        top: 700px;
        .role_img {
          width: 900px;
        }
        .role_txt {
          position: absolute;
          left: 500px;
          top: 280px;
          z-index: 5;
        }
      }
    }
    .role_cloud {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: -10px;
      z-index: 2;
    }
  }
}

.footer {
  position: relative;
  margin-top: -12px;
  padding-bottom: 30px;
  .footer_bg {
    width: 100%;
    display: block;
  }
  .mb_footer_bg {
    display: none;
  }
  .business_btn {
    position: absolute;
    display: inline-block;
    width: 620px;
    height: 75px;
    top: 130px;
    left: 300px;
    cursor: pointer;
  }
  .pro_btn {
    position: absolute;
    display: inline-block;
    width: 210px;
    height: 75px;
    top: 130px;
    left: 960px;
    cursor: pointer;
  }
  .user_btn {
    position: absolute;
    display: inline-block;
    width: 500px;
    height: 75px;
    top: 130px;
    left: 1230px;
    cursor: pointer;
  }
  .logo {
    position: absolute;
    width: 350px;
    top: 20px;
    right: 200px;
  }
  .funds_btn {
    position: absolute;
    width: 580px;
    height: 75px;
    top: 220px;
    left: 300px;
    cursor: pointer;
  }
}

// 移动端
@media screen and (max-width: 750px) {
  .bg {
    display: none;
  }
  .mb_bg {
    width: 100%;
    display: block;
  }
  .video-mask {
    video {
      width: 100%;
    }
  }
  .section1 {
    .play-btn {
      width: 13%;
      top: 72%;
      left: 75%;
    }
    .download {
      width: 100%;
      bottom: 0px;
      right: 0%;
      a {
        display: inline-block;
        width: 1350px;
      }
    }
  }
  .section2 {
    .news,
    .swiper {
      width: 100%;
      display: block;
    }
    .swiper {
      height: auto;

      .swiper-pagination {
        bottom: 8%;
      }
      /deep/.swiper-pagination-bullet {
        width: 140px;
        height: 35px;
        margin: 0 50px;
      }
    }

    .news {
      height: 2800px;
      background: #fff;
      .news_tags {
        position: absolute;
        width: 100%;
        height: 75%;
        top: 5%;
        li {
          font-size: 130px;
          padding-bottom: 50px;
          margin-bottom: 50px;
          .tag {
            width: 20%;
            padding: 30px 0px;
            border-radius: 20px;
          }
          .title {
            width: 50%;
            margin: 0 50px;
          }
        }
      }
      .more {
        width: 30%;
        bottom: 11%;
        img {
          width: 100%;
        }
      }
    }
  }

  .frist {
    top: 3%;
    width: 95%;
    .list {
      height: 3800px;
    }
  }

  .second .roles {
    position: absolute;
    bottom: 100px;
    height: 2000px;
    .role_cloud {
      height: 300px;
      bottom: -20px;
    }
    > div {
      .role_txt {
        width: 280px;
        position: absolute;
      }
      &:nth-child(1) {
        top: 0px;
        left: 700px;
        .role_img {
          width: 900px;
        }
        .role_txt {
          top: 280px;
          left: 0px;
        }
      }
      &:nth-child(2) {
        top: -150px;
        left: 1100px;
        .role_img {
          width: 1500px;
        }
        .role_txt {
          top: 350px;
          left: 300px;
        }
      }
      &:nth-child(3) {
        left: 1700px;
        top: 0px;
        z-index: -1;
        .role_img {
          width: 1600px;
        }
        .role_txt {
          top: 330px;
          right: 250px;
        }
      }
      &:nth-child(4) {
        top: 700px;
        left: 300px;
        z-index: 2;
        .role_img {
          width: 1300px;
        }
        .role_txt {
          position: absolute;
          left: 380px;
          top: 300px;
        }
      }
      &:nth-child(5) {
        left: 850px;
        top: 650px;
        z-index: 1;
        .role_img {
          width: 1400px;
        }
        .role_txt {
          position: absolute;
          left: 500px;
          top: 300px;
        }
      }
      &:nth-child(6) {
        left: 1500px;
        top: 700px;
        .role_img {
          width: 1050px;
        }
        .role_txt {
          position: absolute;
          left: 600px;
          top: 300px;
          z-index: 5;
        }
      }
      &:nth-child(7) {
        left: 2200px;
        top: 700px;
        .role_img {
          width: 1200px;
        }
        .role_txt {
          position: absolute;
          left: 600px;
          top: 300px;
          z-index: 5;
        }
      }
    }
  }

  .footer {
    .footer_bg {
      display: none;
    }
    .mb_footer_bg {
      width: 100%;
      display: block;
    }

    .business_btn {
      width: 600px;
      height: 100px;
      top: 110px;
      left: 310px;
    }
    .pro_btn {
      width: 250px;
      height: 100px;
      top: 100px;
      left: 950px;
    }
    .user_btn {
      width: 500px;
      height: 100px;
      top: 100px;
      left: 1200px;
    }
  }
}
</style>
